import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useHistory } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// core components
import Button from "components/CustomButtons/Button.js";
import { infoColor } from "assets/jss/material-dashboard-pro-react.js";

import styles from 'views/component/Styles.js'
import { grayColor } from "assets/jss/material-dashboard-pro-react";

import ConditionList from 'views/aps/ConditionList'
import ProductionList from 'views/aps/ProductionList'
import APSResultView from 'views/aps/APSResultView'

const useStyles = makeStyles(styles);

export default function APSDataUpload(props) {
    const { location } = props;
    const classes = useStyles();
    const history = useHistory();

    const [factory, setFactory] = useState({});

    const [tabIndex, setTabIndex] = useState(0);
    const [completed, setCompleted] = useState([false, false, false]);
    const [nextStep, setNextStep] = useState(false);

    const steps = ["기준 정보 입력", "생산 정보 입력", "지능형 생산계획"];
    const handleStep = function (index) {
        if (index == 0 || completed[index - 1]) {
            setTabIndex(index);
        }
    };

    useEffect(() => {
        if (location.state) {
            setFactory(location.state);
        }
    }, [location]);

    useEffect(() => {
        setNextStep(completed[tabIndex]);
    }, [tabIndex, completed]);

    useEffect(() => {
        updateAPSData(null, true);
    }, [factory]);

    const updateAPSData = function (data, updateIndex) {
        if (Object.keys(factory).length !== 0) {
            axios.all([axios.get('aps/list/routing', { params: factory }), axios.get('aps/list/productionPlan', { params: factory })]).then(
                axios.spread((routing, plan) => {
                    if (plan.data.data.length !== 0) {
                        setCompleted([true, true, false]);
                        if (updateIndex) {
                            setTabIndex(2);
                        }
                    } else if (routing.data.data.length !== 0) {
                        setCompleted([true, false, false]);
                        if (updateIndex) {
                            setTabIndex(1);
                        }
                    } else {
                        setCompleted([false, false, false]);
                        if (updateIndex) {
                            setTabIndex(0);
                        }
                    }
                })
            )
        }
    };

    return (< div >
        <div
            style={{
                backgroundColor: 'white', padding: '20px 10px', borderBottom: '3px solid' + infoColor[0],
                marginLeft: '-15px', marginRight: '-15px'
            }}>
            <Button className={classes.left} onClick={() => history.push('../aps/work')} simple>이전 페이지</Button>
            {tabIndex === steps.length - 1 ? null :
                nextStep ?
                    <Button className={classes.right}
                        onClick={() => handleStep(tabIndex + 1)} color='black'>다음 단계로 이동</Button> : null}
            <div style={{ width: '800px', margin: 'auto', paddingTop: '5px' }}>
                {steps.map((item, index) =>
                    <div style={{ display: 'inline-flex', alignItems: 'center' }} onClick={() => handleStep(index)} key={index}>
                        <Button round justIcon size="sm" color={tabIndex === index ? 'info' : 'gray'}
                            disabled={index !== 0 && !completed[index - 1]}>{index + 1}</Button>
                        <Button simple size="sm" color={tabIndex === index ? 'info' : 'gray'}
                            style={{ padding: '0px 10px', fontSize: '20px' }}
                            disabled={index !== 0 && !completed[index - 1]}>{item}</Button>
                        {index === steps.length - 1 ? null :
                            <ArrowForwardIosIcon htmlColor={tabIndex === index ? infoColor[0] : grayColor[0]}
                                style={{ marginRight: '30px', marginLeft: '20px' }} />}
                    </div>
                )}

            </div>
        </div>
        {tabIndex === 0 ?
            <ConditionList factory={factory} onSave={updateAPSData} />
            : tabIndex === 1 ?
                <ProductionList factory={factory} onSave={updateAPSData} />
                : tabIndex === 2 ?
                    <APSResultView factory={factory} />
                    : null}
    </div >
    );
}